module.exports = __webpack_public_path__ + "img/noticia1.8ddd7880.png";